import { CustomizationEditScreen } from '../../../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <CustomizationEditScreen />;
}
